module.exports = __webpack_public_path__ + "static/img/何慧君1.237d7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/何慧君1.png
// module id = QDj2
// module chunks = 1